import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { tagReport } from '../models/tag-report.model';

@Injectable({
  providedIn: 'root'
})
export class TagReportService {

  constructor(private _http: HttpClient) { }

  getTagReport(tagRpt : tagReport): Observable<any> {
    return this._http.post<any>(environment.config.BASE_API_URL + 'LotTagging/PostLotTaggingReport', tagRpt);
    
  }
}
